// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  workspaceId: __t.u64(),
  messageId: __t.u64(),
  attachmentId: __t.u64(),
  repo: __t.string(),
  branch: __t.string(),
  commitMessage: __t.string(),
  filesJson: __t.string(),
};
